/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

interface Props {
  className: string;
}

const smallAttributes = {
  fill: 'none',
  strokeMiterlimit: 10,
  strokeWidth: 1.25,
};

const Small = (props: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 16 16">
    <g>
      <path {...smallAttributes} strokeLinecap="round" className={props.className} d="M11.23,1.33,8.56,4a2.39,2.39,0,0,0-.7,1.86l.28,4.28A2.39,2.39,0,0,1,7.44,12L4.77,14.67" />
      <path {...smallAttributes} strokeLinecap="round" className={props.className} d="M14.67,4.77,12,7.44a2.39,2.39,0,0,1-1.86.7L5.86,7.86A2.39,2.39,0,0,0,4,8.56L1.33,11.23" />
      <line {...smallAttributes} strokeLinecap="round" className={props.className} x1="12" y1="7.44" x2="10.19" y2="5.63" />
      <line {...smallAttributes} strokeLinecap="round" className={props.className} x1="13.43" y1="6.01" x2="11.08" y2="3.66" />
      <line {...smallAttributes} strokeLinecap="round" className={props.className} x1="5.33" y1="10.84" x2="3.53" y2="9.03" />
      <line {...smallAttributes} strokeLinecap="round" className={props.className} x1="4.47" y1="12.78" x2="2.13" y2="10.43" />
    </g>
  </svg>
);

const mediumAttributes = {
  fill: 'none',
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
};

const Medium = (props: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24">
    <g>
      <path {...mediumAttributes} strokeLinecap="round" className={props.className} d="M16.84,2l-4,4a3.6,3.6,0,0,0-1.05,2.79l.42,6.42A3.6,3.6,0,0,1,11.16,18l-4,4" />
      <path {...mediumAttributes} strokeLinecap="round" className={props.className} d="M22,7.16l-4,4a3.6,3.6,0,0,1-2.79,1.05l-6.42-.42A3.6,3.6,0,0,0,6,12.84l-4,4" />
      <line {...mediumAttributes} strokeLinecap="round" className={props.className} x1="18" y1="11.16" x2="15.29" y2="8.45" />
      <line {...mediumAttributes} strokeLinecap="round" className={props.className} x1="20.15" y1="9.02" x2="16.63" y2="5.5" />
      <line {...mediumAttributes} strokeLinecap="round" className={props.className} x1="8" y1="16.26" x2="5.29" y2="13.55" />
      <line {...mediumAttributes} strokeLinecap="round" className={props.className} x1="6.71" y1="19.17" x2="3.19" y2="15.65" />
    </g>
  </svg>
)

const largeAttributes = {
  fill: 'none',
  strokeMiterlimit: 10,
  strokeWidth: 2,
};

const Large = (props: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 36 36">
    <g>
      <path {...largeAttributes} strokeLinecap="round" className={props.className} d="M25.26,3l-6,6a5.42,5.42,0,0,0-1.58,4.19l.64,9.62A5.42,5.42,0,0,1,16.74,27l-6,6" />
      <path {...largeAttributes} strokeLinecap="round" className={props.className} d="M33,10.74l-6,6a5.42,5.42,0,0,1-4.19,1.58l-9.62-.64A5.42,5.42,0,0,0,9,19.26l-6,6" />
      <line {...largeAttributes} strokeLinecap="round" className={props.className} x1="27" y1="16.74" x2="22.93" y2="12.68" />
      <line {...largeAttributes} strokeLinecap="round" className={props.className} x1="30.22" y1="13.52" x2="24.94" y2="8.24" />
      <line {...largeAttributes} strokeLinecap="round" className={props.className} x1="12" y1="24.39" x2="7.93" y2="20.33" />
      <line {...largeAttributes} strokeLinecap="round" className={props.className} x1="10.06" y1="28.76" x2="4.78" y2="23.48" />
    </g>
  </svg>
)

const extraLargeAttributes = {
  fill: 'none',
  strokeMiterlimit: 10,
  strokeWidth: 2.75,
};


const ExtraLarge = (props: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="56" width="56" viewBox="0 0 56 56">
    <g>
      <path {...extraLargeAttributes} strokeLinecap="round" className={props.className} d="M39.29,4.67,30,14a8.44,8.44,0,0,0-2.45,6.51l1,15A8.44,8.44,0,0,1,26.05,42l-9.34,9.34" />
      <path {...extraLargeAttributes} strokeLinecap="round" className={props.className} d="M51.33,16.71,42,26.05a8.44,8.44,0,0,1-6.51,2.45l-15-1A8.44,8.44,0,0,0,14,30L4.67,39.29" />
      <line {...extraLargeAttributes} strokeLinecap="round" className={props.className} x1="41.99" y1="26.05" x2="35.67" y2="19.72" />
      <line {...extraLargeAttributes} strokeLinecap="round" className={props.className} x1="47.01" y1="21.04" x2="38.79" y2="12.82" />
      <line {...extraLargeAttributes} strokeLinecap="round" className={props.className} x1="18.67" y1="37.94" x2="12.34" y2="31.62" />
      <line {...extraLargeAttributes} strokeLinecap="round" className={props.className} x1="15.65" y1="44.73" x2="7.44" y2="36.52" />
    </g>
  </svg>
)

const IconGenes = {
  Small,
  Medium,
  Large,
  ExtraLarge,
};

export default IconGenes;
